<template>
  <div class="wrapper-image-credit">
    <button class="transparent-button"
            type="button"
            @click="openEditor">Image Credit
    </button>

    <div tabindex="-1" role="dialog" class="modal fade">
      <div role="document" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Image Credit</h4>
          </div>

          <div class="modal-body">
            <TextEditor v-model="credit.text"/>
          </div>
          <div class="modal-footer">
            <button type="button" class="big-purple-button" @click="save">Save</button>
            <button type="button" data-dismiss="modal" class="btn btn-default">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextEditor from './TextEditor';

export default {
  components: {
    TextEditor,
  },

  props: {
    value: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      modalElement: null,

      credit: {
        text: '',
      },
    };
  },

  created() {
    this.credit = this.value;
  },

  watch: {
    value() {
      this.credit = this.value;
    }
  },

  methods: {
    openEditor(event) {
      this.$nextTick(() => {
        this.$children.forEach((child) => {
          child.$emit('refreshEditor');
        });
      });

      this.modalElement = event.target.parentElement.lastChild;

      $(this.modalElement).modal('show');
    },

    save() {
      if (!this.credit.id) {
        this.updateLocal();

        return;
      }

      axios.put(`/api/hyperlinks/${this.credit.id}`, this.credit)
        .then(() => {
          this.updateLocal();
        })
        .catch(() => {
          toastr.error(`Whoops! Something went wrong! Please try again.`);
        });
    },

    updateLocal() {
      this.$emit('input', this.credit);
      this.$emit('updated', this.credit);

      $(this.modalElement).modal('hide');
    }
  }
};
</script>

<style scoped>
  .wrapper-image-credit {
    display: inline-flex;
  }
</style>
